export default __webpack_public_path__ + "static/media/InstrumentSerif-Italic.d5931150.ttf";